export default "__VITE_ASSET__BOLKx2qZ__"